const initialState = {
  //counter: 0
  zero: 0,
  one: 1,
  two: 2,
  three: 3,
  four: 4,
  five: 5,
  six: 6,
  seven: 7,
  eight: 8,
  nine: 9
};

const reducer = (state = initialState, action) => {
  if (action.type == "INCREMENT") {
    return {
      counter: state.counter + 1
    };
  }

  if (action.type == "DECREMENT") {
    if (state.counter == 0) {
      alert("minimum level reached");
    } else {
      return {
        counter: state.counter - 1
      };
    }
  }
  return state;
};

export default reducer;
